import { subMonths } from "date-fns";
import { LAST_3_MONTHS_FILTER } from "features/purchaseHistory/purchaseHistoryPeriod";

import type { ParsedSettlement } from "../../types/parsedSettlement";

type Input = {
  filter: string;
  settlements: ParsedSettlement[];
};

type FilterSettlementsByPeriod = (input: Input) => ParsedSettlement[];

// 期間でフィルタリング
// 直近3ヶ月/年別(購入履歴がある年のみ表示)
export const filterSettlementsByPeriod: FilterSettlementsByPeriod = (input) => {
  const { filter, settlements } = input;

  if (filter === LAST_3_MONTHS_FILTER) {
    const threeMonthsAgo = subMonths(new Date(), 3);

    return settlements.filter((settlement) => {
      if (settlement.createdAt !== null && settlement.createdAt !== undefined) {
        return settlement.createdAt.toDate() >= threeMonthsAgo;
      }
      return false;
    });
  }

  const selectedYear = Number(filter);
  if (Number.isNaN(selectedYear)) {
    return settlements;
  }

  return settlements.filter((settlement) => {
    if (settlement.createdAt !== null && settlement.createdAt !== undefined) {
      return settlement.createdAt.toDate().getFullYear() === selectedYear;
    }
    return false;
  });
};
